import React from 'react';
import { motion } from 'framer-motion';
import { CheckCircle2 } from 'lucide-react';
import { SectionHeading } from './SectionHeading';
import { CTAButton } from './CTAButton';
export function CursAbcCurriculum() {
  const curriculum = [{
    title: 'Vei descoperi sensul adevăratei bogății.',
    desc: 'Prosperitatea nu e doar despre bani. E despre a avea din plin pe toate planurile: sănătate, relații, liniște, libertate. Aici înțelegi ce înseamnă cu adevărat să fii prosper.'
  }, {
    title: 'Vei identifica gândurile și credințele limitative care te țin pe loc.',
    desc: 'Credințe precum "nu merit", "nu pot", "e greu" sau "nu e suficient" lucrează în subconștientul tău fără să îți dai seama. Le scoți la lumină ca să le poți schimba.'
  }, {
    title: 'Vei învăța cum să te eliberezi de vechile convingeri care nu îți mai sunt de folos.',
    desc: 'Nu doar le identifici, ci primești tehnici concrete prin care le elimini și le înlocuiești cu o mentalitate care te susține.'
  }, {
    title: 'Vei descoperi afirmații prin care să îți creezi o viață prosperă.',
    desc: 'Afirmațiile, folosite corect și constant, schimbă modul în care gândești și acționezi. Aici primești afirmații ghidate, testate, care funcționează.'
  }, {
    title: 'Vei învăța cum să îți creezi propria hartă a comorilor.',
    desc: 'Un instrument de vizualizare care îți clarifică ce îți dorești cu adevărat, îți dă direcție și te ajută să atragi ceea ce vrei în viața ta.'
  }, {
    title: 'Vei capăta claritate, direcție și încredere.',
    desc: 'La finalul cursului nu mai spui "nu știu ce vreau." Știi exact încotro mergi, de ce mergi acolo și ce trebuie să faci în fiecare zi ca să ai o viață prosperă.'
  }];
  return <section className="py-20 lg:py-32 bg-brand-cream relative" data-id="element-855">
      <div className="max-w-4xl mx-auto px-6" data-id="element-856">
        <SectionHeading title="Ce vei descoperi în cursul ABC-ul Prosperității" data-id="element-857" />

        <div className="space-y-5 mb-16" data-id="element-858">
          {curriculum.map((item, index) => <motion.div key={index} initial={{
          opacity: 0,
          y: 20
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true,
          margin: '-50px'
        }} transition={{
          duration: 0.5,
          delay: index * 0.08
        }} className="flex gap-4 items-start bg-white p-6 md:p-7 rounded-2xl shadow-sm border border-brand-text/5 hover:shadow-warm transition-shadow" data-id="element-859">
              <div className="flex-shrink-0 mt-1 w-10 h-10 rounded-full bg-brand-gold/10 flex items-center justify-center" data-id="element-860">
                <CheckCircle2 className="w-6 h-6 text-brand-gold" data-id="element-861" />
              </div>
              <div data-id="element-862">
                <h3 className="font-bold text-lg text-brand-text mb-2" data-id="element-863">
                  {item.title}
                </h3>
                <p className="text-brand-textSec leading-relaxed" data-id="element-864">
                  {item.desc}
                </p>
              </div>
            </motion.div>)}
        </div>

        <motion.div initial={{
        opacity: 0
      }} whileInView={{
        opacity: 1
      }} viewport={{
        once: true
      }} className="flex justify-center" data-id="element-865">
          <CTAButton data-id="element-866" />
        </motion.div>
      </div>
    </section>;
}